/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_BackInputs */

const en_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to blog`)
};

const es_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al blog`)
};

const de_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Blog`)
};

const zh_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回博客`)
};

const ar_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العودة إلى المدونة`)
};

const fr_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour au blog`)
};

const vi_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại blog`)
};

const sw_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rudi kwenye blogu`)
};

const th_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับไปที่บล็อก`)
};

const bs_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazad na blog`)
};

const ja_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブログに戻る`)
};

const ko_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블로그로 가기`)
};

const pt_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao blog`)
};

const it_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna al blog`)
};

const sv_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillbaka till bloggen`)
};

const nl_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar blog`)
};

const da_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbage til bloggen`)
};

const nb_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbake til bloggen`)
};

const fi_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takaisin blogiin`)
};

const pl_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powrót do bloga`)
};

const ru_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться в блог`)
};

const tr_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloga dön`)
};

const hi_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ब्लॉग`)
};

const id_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke blog`)
};

const ms_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembali ke blog`)
};

const cs_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na blog`)
};

const el_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επιστροφή στο blog`)
};

const he_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חזרה לבלוג`)
};

const af_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug na blog`)
};

const hu_blog_back = /** @type {(inputs: Blog_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vissza a bloghoz`)
};

/**
* | output |
* | --- |
* | "Back to blog" |
*
* @param {Blog_BackInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_back = /** @type {((inputs?: Blog_BackInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_BackInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_back(inputs)
	if (locale === "de") return de_blog_back(inputs)
	if (locale === "zh") return zh_blog_back(inputs)
	if (locale === "ar") return ar_blog_back(inputs)
	if (locale === "fr") return fr_blog_back(inputs)
	if (locale === "vi") return vi_blog_back(inputs)
	if (locale === "sw") return sw_blog_back(inputs)
	if (locale === "th") return th_blog_back(inputs)
	if (locale === "bs") return bs_blog_back(inputs)
	if (locale === "ja") return ja_blog_back(inputs)
	if (locale === "ko") return ko_blog_back(inputs)
	if (locale === "pt") return pt_blog_back(inputs)
	if (locale === "it") return it_blog_back(inputs)
	if (locale === "sv") return sv_blog_back(inputs)
	if (locale === "nl") return nl_blog_back(inputs)
	if (locale === "da") return da_blog_back(inputs)
	if (locale === "nb") return nb_blog_back(inputs)
	if (locale === "fi") return fi_blog_back(inputs)
	if (locale === "pl") return pl_blog_back(inputs)
	if (locale === "ru") return ru_blog_back(inputs)
	if (locale === "tr") return tr_blog_back(inputs)
	if (locale === "hi") return hi_blog_back(inputs)
	if (locale === "id") return id_blog_back(inputs)
	if (locale === "ms") return ms_blog_back(inputs)
	if (locale === "cs") return cs_blog_back(inputs)
	if (locale === "el") return el_blog_back(inputs)
	if (locale === "he") return he_blog_back(inputs)
	if (locale === "af") return af_blog_back(inputs)
	if (locale === "hu") return hu_blog_back(inputs)
	return en_blog_back(inputs)
});